import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNy: CultureInfo = {
  name: 'ny',
  displayName: 'Nyanja',
  iso3LanguageCode: 'nya',
  iso2LanguageCode: 'ny',
  ietfLanguageTag: 'ny',
  parent: null
};
